export default {
  text: [
    "Unusual situation? Tight deadline? Stuck?",
    "We always find a way to get the job done."
  ],
  linkText: "Talk to us"
};
